import { render, staticRenderFns } from "./FooterPrensa.vue?vue&type=template&id=1c00544c"
import script from "./FooterPrensa.vue?vue&type=script&lang=js"
export * from "./FooterPrensa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports